import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const categoryThumbnails = [
  "https://readdy.ai/api/search-image?query=Clean%20fashion%20photography%20of%20white%20sneakers%20on%20soft%20mint%20green%20pastel%20background%2C%20editorial%20product%20styling%2C%20natural%20window%20light%2C%20minimalist%20aesthetic&width=120&height=120&seq=mob-cat-shoes&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Clean%20fashion%20photography%20of%20a%20grey%20hoodie%20folded%20on%20soft%20terracotta%20background%2C%20editorial%20product%20styling%2C%20natural%20light%2C%20minimalist%20aesthetic&width=120&height=120&seq=mob-cat-hoodies&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Clean%20fashion%20photography%20of%20white%20t-shirt%20on%20soft%20dusty%20blue%20background%2C%20editorial%20product%20styling%2C%20natural%20light%2C%20minimalist%20aesthetic&width=120&height=120&seq=mob-cat-tshirts&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Clean%20fashion%20photography%20of%20bomber%20jacket%20on%20soft%20sand%20beige%20background%2C%20editorial%20product%20styling%2C%20natural%20light%2C%20minimalist%20aesthetic&width=120&height=120&seq=mob-cat-jackets&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Clean%20fashion%20photography%20of%20pants%20folded%20on%20soft%20blush%20pink%20background%2C%20editorial%20product%20styling%2C%20natural%20light%2C%20minimalist%20aesthetic&width=120&height=120&seq=mob-cat-pants&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Clean%20fashion%20photography%20of%20baseball%20cap%20on%20soft%20sage%20green%20background%2C%20editorial%20product%20styling%2C%20natural%20light%2C%20minimalist%20aesthetic&width=120&height=120&seq=mob-cat-headwear&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Clean%20fashion%20photography%20of%20sweatsuit%20set%20on%20soft%20lavender%20background%2C%20editorial%20product%20styling%2C%20natural%20light%2C%20minimalist%20aesthetic&width=120&height=120&seq=mob-cat-sets&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Clean%20fashion%20photography%20of%20cotton%20underwear%20folded%20on%20soft%20warm%20oatmeal%20background%2C%20editorial%20product%20styling%2C%20natural%20light%2C%20minimalist%20aesthetic&width=120&height=120&seq=mob-cat-underwear&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Clean%20fashion%20photography%20of%20sports%20jersey%20on%20soft%20sky%20blue%20background%2C%20editorial%20product%20styling%2C%20natural%20light%2C%20minimalist%20aesthetic&width=120&height=120&seq=mob-cat-jersey&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Clean%20fashion%20photography%20of%20sunglasses%20and%20watch%20on%20soft%20coral%20background%2C%20editorial%20product%20styling%2C%20natural%20light%2C%20minimalist%20aesthetic&width=120&height=120&seq=mob-cat-accessories&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Clean%20fashion%20photography%20of%20stylish%20backpack%20on%20soft%20teal%20background%2C%20editorial%20product%20styling%2C%20natural%20light%2C%20minimalist%20aesthetic&width=120&height=120&seq=mob-cat-bags&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Clean%20fashion%20photography%20of%20leather%20belt%20on%20soft%20warm%20beige%20background%2C%20editorial%20product%20styling%2C%20natural%20light%2C%20minimalist%20aesthetic&width=120&height=120&seq=mob-cat-belts&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Clean%20fashion%20photography%20of%20perfume%20bottle%20on%20soft%20lilac%20background%2C%20editorial%20product%20styling%2C%20natural%20light%2C%20minimalist%20aesthetic&width=120&height=120&seq=mob-cat-perfumes&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Clean%20fashion%20photography%20of%20lifestyle%20products%20on%20soft%20peach%20background%2C%20editorial%20product%20styling%2C%20natural%20light%2C%20minimalist%20aesthetic&width=120&height=120&seq=mob-cat-other&orientation=squarish",
];

const articleLinks = [
  { to: '/artykul/przewodnik-kakobuy-spreadsheet', label: 'Kompletny Przewodnik' },
  { to: '/artykul/bezpieczenstwo-kakobuy-spreadsheet', label: 'Bezpieczeństwo' },
  { to: '/artykul/poradnik-zakupowy-kakobuy', label: 'Poradnik Zakupowy' },
  { to: '/artykul/jak-znalezc-najlepsze-produkty-kakobuy', label: 'Jak Znaleźć Produkty' },
];

export default function Navbar() {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const navLinks = [
    { to: "/", label: t('nav.home'), icon: 'ri-home-4-line' },
    { to: "/artykul/poradnik-zakupowy-kakobuy", label: t('nav.shopping_guide'), icon: 'ri-shopping-cart-line' },
    { to: "/artykul/przewodnik-kakobuy-spreadsheet", label: t('nav.article'), icon: 'ri-article-line' },
  ];

  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70' : 'bg-transparent'}`}>
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          <div className="flex items-center gap-8">
            <Link to="/" className="flex items-center gap-2 group cursor-pointer">
              <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-table-line text-background-50 text-lg"></i>
              </div>
              <span className={`font-heading text-lg md:text-xl font-semibold whitespace-nowrap ${scrolled ? 'text-foreground-900' : 'text-background-50'}`}>
                KakobuyFinds
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm whitespace-nowrap transition-colors cursor-pointer ${scrolled ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100' : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'}`}
                >
                  <i className={`${link.icon} text-sm`}></i>
                  {link.label}
                </Link>
              ))}

              <div ref={dropdownRef} className="relative">
                <button
                  onClick={() => setIsOpen(!isOpen)}
                  className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm whitespace-nowrap transition-colors cursor-pointer ${scrolled ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100' : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'}`}
                >
                  <i className="ri-grid-line text-sm"></i>
                  {t('nav.categories')}
                  <i className={`ri-arrow-down-s-line text-sm transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}></i>
                </button>

                {isOpen && (
                  <div className={`absolute top-full left-0 mt-2 w-72 rounded-xl border overflow-hidden animate-[fadeIn_0.15s_ease-out] ${scrolled ? 'bg-background-50 border-background-200/70 shadow-sm' : 'bg-background-50 border-background-200/70'}`}>
                    <div className="py-2 max-h-80 overflow-y-auto">
                      {categories.map((cat, idx) => (
                        <a
                          key={cat.nameKey}
                          href={cat.link}
                          target="_blank"
                          rel="noopener nofollow"
                          className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
                        >
                          <div className="w-8 h-8 rounded-lg overflow-hidden flex-shrink-0 bg-background-100">
                            <img src={categoryThumbnails[idx]} alt="" className="w-full h-full object-cover object-top" />
                          </div>
                          {t(cat.nameKey)}
                        </a>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              <button
                onClick={() => scrollToSection('faq')}
                className={`px-3 py-2 rounded-lg text-sm whitespace-nowrap transition-colors cursor-pointer ${scrolled ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100' : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'}`}
              >
                {t('nav.faq')}
              </button>
            </div>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className={`px-4 py-2 rounded-full border text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${scrolled ? 'border-primary-500 text-primary-600 hover:bg-primary-50' : 'border-background-50/60 text-background-50 hover:bg-white/10'}`}
            >
              {t('hero.cta_buy')}
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              {t('hero.cta_primary')}
            </a>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer ${scrolled ? 'text-foreground-700' : 'text-background-50'}`}
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 animate-[fadeIn_0.15s_ease-out] max-h-[80vh] overflow-y-auto">
          <div className="px-4 py-3 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setMobileMenuOpen(false)}
                className="flex items-center gap-3 px-3 py-3 rounded-lg text-sm text-foreground-700 hover:bg-background-100 cursor-pointer"
              >
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-100">
                  <i className={`${link.icon} text-base text-foreground-600`}></i>
                </div>
                {link.label}
              </Link>
            ))}
            <div className="h-px bg-background-200/70 my-2"></div>
            <div className="px-3 py-2 text-xs font-semibold text-foreground-400 uppercase tracking-wider">
              {t('nav.articles')}
            </div>
            {articleLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setMobileMenuOpen(false)}
                className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-foreground-700 hover:bg-background-100 cursor-pointer"
              >
                <div className="w-6 h-6 flex items-center justify-center text-accent-500">
                  <i className="ri-article-line text-sm"></i>
                </div>
                {link.label}
              </Link>
            ))}
            <div className="h-px bg-background-200/70 my-2"></div>
            <div className="px-3 py-2 text-xs font-semibold text-foreground-400 uppercase tracking-wider">
              {t('nav.categories')}
            </div>
            <div className="grid grid-cols-2 gap-2">
              {categories.map((cat, idx) => (
                <a
                  key={cat.nameKey}
                  href={cat.link}
                  target="_blank"
                  rel="noopener nofollow"
                  onClick={() => setMobileMenuOpen(false)}
                  className="flex items-center gap-2 p-2 rounded-lg text-sm text-foreground-700 hover:bg-background-100 cursor-pointer"
                >
                  <div className="w-10 h-10 rounded-lg overflow-hidden flex-shrink-0 bg-background-100">
                    <img src={categoryThumbnails[idx]} alt="" className="w-full h-full object-cover object-top" />
                  </div>
                  <span className="text-xs whitespace-nowrap truncate">{t(cat.nameKey)}</span>
                </a>
              ))}
            </div>
            <div className="pt-3 flex flex-col gap-2">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full px-4 py-2.5 rounded-full border border-primary-500 text-primary-600 text-sm font-medium text-center whitespace-nowrap cursor-pointer"
              >
                {t('hero.cta_buy')}
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full px-4 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium text-center whitespace-nowrap cursor-pointer"
              >
                {t('hero.cta_primary')}
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}